export class PanasonicDisplayRs232 {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '1.00.01';
        this.power = false;
        this.serialNumber = 'SW12345678';
        this.videoMute = false;
        this.videoSelection = 'HM1';
        this.volume = 50;
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /\x02QRV/i,
                callback: (match) => {
                    this.socket.send(`\x02QRV:${this.firmwareVersion}`);
                },
            },
            {
                name: 'serialNumber',
                regExp: /\x02QSN/i,
                callback: (match) => {
                    this.socket.send(`\x02QSN:${this.serialNumber}`);
                },
            },
            {
                name: 'powerQuery',
                regExp: /\x02QPW/i,
                callback: (match) => {
                    this.socket.send(`\x02QPW:${this.power ? '1' : '0'}`);
                },
            },
            {
                name: 'powerSet',
                regExp: /\x02P(ON|OF)/i,
                callback: (match) => {
                    this.power = match[1] === 'ON';
                    this.socket.send(`\x02P${match[1]}`);
                },
            },
            {
                name: 'videoMuteQuery',
                regExp: /\x02QVM/i,
                callback: (match) => {
                    this.socket.send(`\x02QVM:${this.videoMute ? '1' : '0'}`);
                },
            },
            {
                name: 'videoMuteSet',
                regExp: /\x02VMT:(\d+)/i,
                callback: (match) => {
                    this.videoMute = match[1] === '1';
                    this.socket.send(`\x02VMT:${this.videoMute ? '1' : '0'}`);
                },
            },
            {
                name: 'videoQuery',
                regExp: /\x02QMI/i,
                callback: (match) => {
                    this.socket.send(`\x02QMI:${this.videoSelection}`);
                },
            },
            {
                name: 'videoSet',
                regExp: /\x02IMS:(.+)/i,
                callback: (match) => {
                    this.videoSelection = match[1];
                    this.socket.send(`\x02IMS:${match[1]}`);
                },
            },
            {
                name: 'volumeQuery',
                regExp: /\x02QAV/i,
                callback: (match) => {
                    this.socket.send(`\x02QAV:${this.volume.toString().padStart(3, '0')}`);
                },
            },
            {
                name: 'volumeSet',
                regExp: /\x02AVL:(\d+)/i,
                callback: (match) => {
                    this.volume = parseInt(match[1], 10);
                    this.socket.send(`\x02AVL:${match[1]}`);
                },
            },
            {
                name: 'volumeMuteQuery',
                regExp: /\x02QAM/i,
                callback: (match) => {
                    this.socket.send(`\x02QAM:${this.volumeMute ? '1' : '0'}`);
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /\x02AMT:(\d+)/i,
                callback: (match) => {
                    this.volumeMute = match[1] === '1';
                    this.socket.send(`\x02AMT:${match[1]}`);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`ERR1`);
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code;
            if (this.videoSelection === code)
                return;
            if (lowestCode === undefined || code < lowestCode) {
                lowestCode = code;
            }
        }
        this.videoSelection = lowestCode !== null && lowestCode !== void 0 ? lowestCode : 'HD1';
    }
}
PanasonicDisplayRs232.emulatorType = 'socketEmulator';
PanasonicDisplayRs232.key = '-LdZiufqBYSiTAHHNZvL';
